import React, { cloneElement, useState } from 'react';

// Utils
import { useDispatch, useSelector } from 'react-redux';
import { unMaksPhoneNumber } from '../../../utils/formatCellNumbers';

// Actions
import { createInviteToFamily } from '../store/actions';
import { validateCellPhone } from '../../../utils/validators';

const AddNumberFamilyHoc = ({ children, setInvitingNumber }) => {
  const [inviteError, setInviteError] = useState('');

  const dispatch = useDispatch();

  const { content, popupRequestStatus } = useSelector((state) => state.family);
  const { popups: { addNumber } } = content;
  const {
    title, label, description, buttonText, wholesalePriceTitle, byNumberedPriceTitle,
  } = addNumber;

  const handleCreateInvite = (event, ctn) => {
    event.preventDefault();
    const unMaskedCtn = unMaksPhoneNumber(ctn);
    setInvitingNumber(unMaskedCtn);

    dispatch(createInviteToFamily(unMaskedCtn));
  };

  return (
    cloneElement(children, {
      title,
      label,
      description,
      buttonText,
      wholesalePriceTitle,
      byNumberedPriceTitle,
      maskFormat: '+7 ### ###-##-##',
      handleCreateInvite,
      validateCellPhone,
      isLoading: popupRequestStatus?.isLoading,
      inviteError,
      setInviteError,
    })
  );
};

export { AddNumberFamilyHoc };
